import { Box, List, ListItemText, Typography } from "@mui/material";
import { listItemTextClasses } from "@mui/material";

import { typographyClasses } from "@mui/material/Typography";
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
export const Wrapper = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}));


export const ListWrapper = styled(List)`

    background: #fff;
`
export const EventWrapper = styled(Box)(({ theme }) => ({
    marginLeft: '16px',
    [theme.breakpoints.down('sm')]: {
        marginTop: '16px',
        marginLeft: 0,
        width: '100%'
    },
    background: '#fff'
}));

export const Title = styled(Typography)`
  padding:8px 16px;
`
export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
    [`&&.${listItemTextClasses.root}>.${listItemTextClasses.secondary}`]: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px'
    },
}));
export const theme = createTheme({
    palette: {
        primary: {
            main: '#408697',
            dark: '#053e85',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: 'inherit !important',
                    padding: 'initial !important',
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {

                },
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                toolbar: {
                    justifyContent: 'flex-end',
                },
                selectLabel: {
                    margin: 0,

                },
                displayedRows: {
                    margin: 0,
                },
                actions: {
                    '& .MuiIconButton-root': {
                        color: '#fff',
                        background: '#0e0e0e',
                        margin: '5px',
                        padding: 'initial !important',
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 0,
                    marginTop: 0
                }
            }
        },

    }
});